/**
 * src/ui/templates.ts
 *
 * Gera fragmentos HTML simples usados pela UI
 * para estados transitórios do componente:
 *
 * - Loader (carregamento assíncrono de dados)
 * - Erro fatal (config inválida, falha de rede, etc.)
 *
 * Observações:
 * - Retorna apenas strings HTML (sem side-effects).
 * - O CSS associado é definido em `styles.ts`.
 * - Não utiliza frameworks ou templating engines
 *   para manter compatibilidade máxima com Moodle.
 */

const PREFIX = 'middag-app-cn';

/**
 * Retorna o HTML do estado de carregamento.
 *
 * Utiliza SVG inline para:
 * - evitar dependência de assets externos
 * - garantir funcionamento offline / CDN isolada
 * - permitir herdar cor via `currentColor`
 */
export function getLoaderHtml(): string {
  return `
    <div class="${PREFIX}-loader" role="status" aria-live="polite">
      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style="margin:auto; display:block;"
      >
        <style>
          .spinner_OSmW {
            animation: spinner_T6OD .7s linear infinite;
          }
          @keyframes spinner_T6OD {
            to { transform: rotate(360deg); }
          }
        </style>
        <path
          class="spinner_OSmW"
          d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
          opacity=".25"
          fill="currentColor"
        />
        <path
          class="spinner_OSmW"
          d="M12,4a8,8,0,0,1,7.89,6.7A1.5,1.5,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.5,1.5,0,0,0,1.48-1.75A8,8,0,0,1,12,4Z"
          fill="currentColor"
        />
      </svg>
      <p style="margin-top:10px;">Carregando...</p>
    </div>
  `;
}

/**
 * Retorna o HTML de erro fatal.
 *
 * @param message Mensagem de erro já tratada pela camada superior.
 *
 * Observação:
 * - O conteúdo NÃO é escapado aqui.
 * - Assume-se que a mensagem venha de fonte confiável
 *   (erros internos controlados).
 */
export function getErrorHtml(message: string): string {
  return `
    <div
      class="${PREFIX}-loader"
      role="alert"
      aria-live="assertive"
      style="color: #d32f2f; text-align: center;"
    >
      <p><strong>Erro:</strong> ${message}</p>
    </div>
  `;
}
